module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkin-google-map history-detail-wrapper",
    attrs: {
      "name": "hres6oe-history-detail"
    }
  }, [_c('div', {
    staticClass: "history-header"
  }, [_c('div', {
    staticClass: "panel-left"
  }, [_c('div', {
    staticClass: "header-row -topic"
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.data.namcust) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "header-row"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.data.dtein) + " - " + _vm._s(_vm.data.dteout) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "header-row"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.data.timin) + " - " + _vm._s(_vm.data.timout) + "\n      ")])]), _vm._v(" "), (_vm.data.flgcanedit === 'Y' && !_vm.flgEdit) ? _c('div', {
    staticClass: "panel-right"
  }, [_c('img', {
    staticClass: "img cursor-pointer",
    attrs: {
      "src": '/static/images/checkin/weekly_icon.png'
    },
    on: {
      "click": function($event) {
        _vm.callEditDetail()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flgEdit),
      expression: "!flgEdit"
    }],
    staticClass: "history-detail"
  }, [((_vm.data.typplace === '3')) ? _c('div', {
    staticClass: "detail-set"
  }, [_c('div', {
    staticClass: "label-box"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['40']) + " :")]), _vm._v(" "), _c('div', {
    staticClass: "data-box"
  }, [_vm._v(_vm._s(_vm.data.new_namcust))])]) : _vm._e(), _vm._v(" "), ((_vm.data.typplace === '3')) ? _c('div', {
    staticClass: "detail-set"
  }, [_c('div', {
    staticClass: "label-box"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['50']) + " :")]), _vm._v(" "), _c('div', {
    staticClass: "data-box"
  }, [_vm._v(_vm._s(_vm.data.namcontact))])]) : _vm._e(), _vm._v(" "), ((_vm.data.typplace === '3')) ? _c('div', {
    staticClass: "detail-set"
  }, [_c('div', {
    staticClass: "label-box"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['60']) + " :")]), _vm._v(" "), _c('div', {
    staticClass: "data-box"
  }, [_vm._v(_vm._s(_vm.data.phone))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-set"
  }, [_c('div', {
    staticClass: "label-box"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['20']) + " :")]), _vm._v(" "), _c('div', {
    staticClass: "data-box"
  }, [_vm._v(_vm._s(_vm.data.namreason))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-set"
  }, [_c('div', {
    staticClass: "label-box"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['30']) + " :")]), _vm._v(" "), _c('div', {
    staticClass: "data-box"
  }, [_vm._v(_vm._s(_vm.data.activity))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-set"
  }, [_c('div', {
    staticClass: "label-box"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['80']) + " :")])]), _vm._v(" "), (_vm.data.filenamei && _vm.pathImage) ? _c('div', {
    staticClass: "checkin-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pathImage + _vm.data.filenamei
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-set"
  }, [_c('div', {
    staticClass: "label-box"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['90']) + " :")])]), _vm._v(" "), (_vm.data.filenameo && _vm.pathImage) ? _c('div', {
    staticClass: "checkin-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pathImage + _vm.data.filenameo
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flgEdit),
      expression: "flgEdit"
    }],
    staticClass: "panel-edit"
  }, [((_vm.detail.typplace === '3')) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['40']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.new_namcust),
      expression: "detail.new_namcust"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "data-vv-name": "new_namcust",
      "name": "input",
      "has-error": _vm.errors.has('new_namcust')
    },
    domProps: {
      "value": (_vm.detail.new_namcust)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "new_namcust", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_namcust')),
      expression: "errors.has('new_namcust')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('new_namcust')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['50']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.namcontact),
      expression: "detail.namcontact"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "data-vv-name": "namcontact",
      "name": "input",
      "has-error": _vm.errors.has('namcontact')
    },
    domProps: {
      "value": (_vm.detail.namcontact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "namcontact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('namcontact')),
      expression: "errors.has('namcontact')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('namcontact')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['60']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.phone),
      expression: "detail.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "data-vv-name": "phone",
      "name": "input",
      "has-error": _vm.errors.has('phone')
    },
    domProps: {
      "value": (_vm.detail.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['20']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.dropdowns,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codreason",
      "has-error": _vm.errors.has('codreason')
    },
    model: {
      value: (_vm.detail.codreason),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codreason", $$v)
      },
      expression: "detail.codreason"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codreason')),
      expression: "errors.has('codreason')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('codreason')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label['HRES6OEC4']['30']) + " "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.activity),
      expression: "detail.activity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:500'),
      expression: "'required|max:500'"
    }],
    staticClass: "normal-input",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "type": "text",
      "name": "input",
      "maxlength": "500",
      "data-vv-name": "activity",
      "has-error": _vm.errors.has('activity')
    },
    domProps: {
      "value": (_vm.detail.activity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "activity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('activity')),
      expression: "errors.has('activity')"
    }],
    staticClass: "validator-text -error"
  }, [_vm._v(_vm._s(_vm.errors.first('activity')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(500)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-button"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flgEdit),
      expression: "!flgEdit"
    }],
    staticClass: "button-md _bg-grey",
    class: _vm.pcDisp ? '' : '-mobile',
    on: {
      "click": function($event) {
        _vm.callBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flgEdit),
      expression: "flgEdit"
    }],
    staticClass: "button-md _bg-green",
    class: _vm.pcDisp ? '' : '-mobile',
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flgEdit),
      expression: "flgEdit"
    }],
    staticClass: "button-md _bg-grey",
    class: _vm.pcDisp ? '' : '-mobile',
    on: {
      "click": function($event) {
        _vm.callCancel()
      }
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-773467e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6oe/historyDetail.vue
// module id = 3897
// module chunks = 1